import React from 'react';
import BizDevTable from './BizDevTable';
export default function BizDevOverview() {
  return (
    <div>
      <BizDevTable />
    </div>
  );
}
